import { type ReactNode } from 'react';

import { Stack } from '@mui/material';

import MiniScreen from '@/designs-dev/handover/MiniScreen';
import { Frame, LibraryShell } from '@/designs-dev/library/LibraryCanvas';
import CareProfileScreen from '@/karehero-app/tell-us-once/intake/CareProfileScreen';
import Flow from '@/karehero-app/tell-us-once/intake/Flow';
import InAppHome from '@/karehero-app/tell-us-once/intake/InAppHome';
import { CARER_INITIALS } from '@/karehero-app/tell-us-once/intake/content';

/** Whole pages, drawn small and live, kept apart from the system. */
const PAGES: { name: string; render: () => ReactNode }[] = [
  { name: 'Home', render: () => <InAppHome /> },
  {
    // The newest onboarding, at its chat.
    name: 'Onboarding',
    render: () => <Flow initial='help-ask' option={2} version='2.1' />,
  },
  {
    name: 'Profile',
    render: () => (
      <CareProfileScreen
        initialTab='profile'
        account={{ initials: CARER_INITIALS }}
      />
    ),
  },
];

const PagesCanvas = () => (
  <LibraryShell title='Pages'>
    <Stack direction='row' spacing={6} sx={{ alignItems: 'flex-start' }}>
      {PAGES.map((page) => (
        <Frame key={page.name} title={page.name}>
          <MiniScreen label={page.name}>{page.render()}</MiniScreen>
        </Frame>
      ))}
    </Stack>
  </LibraryShell>
);

export default PagesCanvas;
